module.exports = __webpack_public_path__ + "static/img/intro_pcga.b85aa78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/intro_pcga.png
// module id = M5Fl
// module chunks = 1